<template>
  <div class="shift-tab">
    <layout-desktop-wrapper no-padding-bottom>
      <shift-details v-if="currentShift"
                     :shift="currentShift"
                     :shift-worker="currentShiftWorker"/>
    </layout-desktop-wrapper>
  </div>
</template>

<script lang="ts" setup>
import LayoutDesktopWrapper from '@app/components/layout/LayoutDesktopWrapper.vue';
import {
  Shift, ShiftWorker,
} from '../types';
import ShiftDetails from './ShiftDetails.vue';

defineProps<{
  currentShift: Shift,
  currentShiftWorker: ShiftWorker,
  isFreelancerInactive?: boolean,
}>();

</script>
